import Vue from 'vue' ;
import Vuex from 'vuex' ;
import {userData2} from "./components/services/auth";

Vue.use ( Vuex ) ;
const requireContext = require.context('./components/services',false,/.*\.js$/);

const user = userData2();

const modules = requireContext.keys().map(file => [
    file.replace(/(^.\/)|(\.js$)/g,''), requireContext(file)
]).reduce((modules,[name,module])=>{
    if(module.namespaced === undefined) {
        module.namespaced = true;
    }

    return {...modules,[name]:module}
},{});
export default new Vuex.Store ( {
    modules,
    state : {
        apiURL : window.location.origin + '/api' ,
        servicePath : window.location.origin ,
        currentUser:user,
        // isLoggedIn: !!user,
    },

    getters: {
        currentUser(state) {
            return state.currentUser;
        },
    },

    mutations:{
        loginSuccess(state,payload){
            state.currentUser = payload;
        },
        logout(state){
            state.currentUser = null;
        },
    },

} )